export default function (locale = document.body.dataset.locale, currency = process.env.MIX_SALES_CURRENCY) {
    return function (amount) {
        if (amount === null) {
            return null;
        }

        return Intl.NumberFormat(locale, {style: 'currency', currency: currency}).format(amount);
    }
}
